// Rails 関連の初期化
require('@rails/ujs').start();
// require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');

// jQuery を読み込み、グローバルに定義（cocoonやBootstrap用）
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// Cocoon
require('@nathanvda/cocoon');

// Bootstrap + Popper（bootstrap.bundle.js に含まれている）
// import 'bootstrap/dist/js/bootstrap.bundle.js'; ← 削除
// Bootstrap JS をインポートして、グローバルに公開
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap  // ← これで bootstrap.Modal などが使えるようになる

// Bootstrap の CSS
import 'bootstrap/dist/css/bootstrap.min.css'

// Bootstrap Icons（必要なら）
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/js/all';

// SCSS スタイル
import '../stylesheets/application.scss';

// その他の外部ライブラリ（必要に応じて）
window.noUiSlider = require('nouislider/dist/nouislider');
window.wNumb = require('./wNumb.js');

// BootstrapのPopover初期化（必要に応じて）
$(function () {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  [...popoverTriggerList].forEach(el => new bootstrap.Popover(el));
});


/*
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('@rails/ujs').start();
// require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
//require('jquery');
import $ from 'jquery'
window.$ = $
window.jQuery = $
require('@nathanvda/cocoon');

import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/js/all';
import '../stylesheets/application.scss';
import 'popper.js';


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
window.noUiSlider = require('nouislider/dist/nouislider');
window.wNumb = require('./wNumb.js')

$(function () {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));
});

*/